import { render, staticRenderFns } from "./StarOutline.vue?vue&type=template&id=76794983&"
import script from "./StarOutline.vue?vue&type=script&lang=ts&"
export * from "./StarOutline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports